export const SOMETHING_WENT_WRONG = "Something went wrong!";
export const TOKEN_ERROR = "Error acquiring token";
export const SESSION_EXPIRED = "Your session has expired!";

export const REQUIRED_VALIDATION_MESSAGE = "This field is required";
